// Seeder.js
import React from "react";
import { seedExpandedTemplates } from "./seedTemplateQuestions";

function Seeder() {
  const handleSeed = async () => {
    await seedExpandedTemplates();
    alert("Questions seeded!");
  };

  return (
    <div style={{ padding: "2rem" }}>
      <button onClick={handleSeed} style={{ padding: "1rem", fontSize: "1rem" }}>
        🚀 Seed Questions into Firebase
      </button>
    </div>
  );
}

export default Seeder;
